import { PUBLISH_RECORD_DATA, PUBLISH_RECORD_DATA_SUCCESS, PUBLISH_RECORD_DATA_ERROR, PUBLISH_RECORD_DATA_EMPTY } from '../../actionType';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const PublishRecord = (state = initialState, action) => {
  switch (action.type) {
    case PUBLISH_RECORD_DATA:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case PUBLISH_RECORD_DATA_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: action?.payload?.message,
      };
      break;

    case PUBLISH_RECORD_DATA_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case PUBLISH_RECORD_DATA_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default PublishRecord;
